import { Component, Input, OnInit } from '@angular/core';
import { Application, Spouse } from 'src/app/applications/application/application';

@Component({
  selector: 'app-case-details',
  templateUrl: './case-details.component.html',
  styleUrls: ['./case-details.component.scss']
})
export class CaseDetailsComponent implements OnInit {
  @Input() application!: Application;
  
  careGivers: Spouse[] = [];
  careGiverType: string[] = [];

  constructor() { }

  ngOnInit(): void {    
    if (this.application.mother !== null) {
      this.careGiverType.push("Mother");
      this.careGivers.push(this.application.mother);
    }

    if (this.application.father !== null) {
      this.careGiverType.push("Father");
      this.careGivers.push(this.application.father);
    }

    if (this.application.guardian !== null) {
      this.careGiverType.push("Guardian");
      this.careGivers.push(this.application.guardian);
    }

    if (this.application.spouse !== null) {
      this.careGiverType.push("Spouse");
      this.careGivers.push(this.application.spouse);
    }
  }

}
